import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createSlots as _createSlots, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = ["innerHTML"];
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = ["href"];
const _hoisted_5 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "gap": "8px",
    "flex": "1 0 0"
  }
};
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = {
  style: {
    "display": "flex",
    "justify-content": "center",
    "align-items": "center",
    "width": "100%",
    "min-width": "270px",
    "align-self": "stretch",
    "height": "25px"
  }
};
const _hoisted_8 = {
  class: "share-of-voice-sublabel"
};
const _hoisted_9 = ["innerHTML"];
const _hoisted_10 = ["innerHTML"];
const _hoisted_11 = {
  class: "product-popover-content"
};
const _hoisted_12 = {
  class: "title-details"
};
const _hoisted_13 = {
  class: "title-asin"
};
const _hoisted_14 = {
  class: "title"
};
const _hoisted_15 = {
  class: "price-ratings"
};
const _hoisted_16 = {
  class: "price"
};
const _hoisted_17 = {
  class: "ratings"
};
const _hoisted_18 = {
  class: "sf-share-of-voice-popover-content"
};
const _hoisted_19 = {
  class: "title-table-header"
};
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", {
  class: "table-header"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "key"
}, "ASIN"), /*#__PURE__*/_createElementVNode("div", {
  class: "attribute"
}, "Freq."), /*#__PURE__*/_createElementVNode("div", {
  class: "attribute"
}, "Best")], -1);
const _hoisted_21 = {
  class: "body"
};
const _hoisted_22 = {
  class: "image-name-asin"
};
const _hoisted_23 = {
  class: "name-asin"
};
const _hoisted_24 = {
  class: "asin"
};
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", {
  class: "bar-background",
  style: {
    flex: '1 0 0',
    borderRadius: '4px',
    height: '4px',
    background: '#E8EBF3'
  }
}, null, -1);
const _hoisted_26 = {
  class: "product-popover-content"
};
const _hoisted_27 = {
  class: "title-details"
};
const _hoisted_28 = {
  class: "title-asin"
};
const _hoisted_29 = {
  class: "title"
};
const _hoisted_30 = {
  class: "price-ratings"
};
const _hoisted_31 = {
  class: "price"
};
const _hoisted_32 = {
  class: "ratings"
};
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", {
  class: "bar-background",
  style: {
    flex: '1 0 0',
    borderRadius: '4px',
    height: '4px',
    background: '#E8EBF3'
  }
}, null, -1);
const _hoisted_34 = {
  class: "product-popover-content impression-share"
};
const _hoisted_35 = {
  class: "impression-share-title-date"
};
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "#impressions per search", -1);
const _hoisted_37 = {
  class: "impression-share-details"
};
const _hoisted_38 = {
  class: "detail-row"
};
const _hoisted_39 = {
  class: "dot-key"
};
const _hoisted_40 = {
  class: "values"
};
const _hoisted_41 = {
  class: "product-popover-content impression-share"
};
const _hoisted_42 = {
  class: "impression-share-title-date"
};
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "Click share", -1);
const _hoisted_44 = {
  class: "impression-share-details"
};
const _hoisted_45 = {
  class: "detail-row"
};
const _hoisted_46 = {
  class: "dot-key"
};
const _hoisted_47 = {
  class: "values"
};
const _hoisted_48 = {
  class: "currencies"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_product_table_group_by = _resolveComponent("product-table-group-by");
  const _component_b_th = _resolveComponent("b-th");
  const _component_hug_value = _resolveComponent("hug-value");
  const _component_b_tr = _resolveComponent("b-tr");
  const _component_wrap_with_arrow = _resolveComponent("wrap-with-arrow");
  const _component_wrap_with_popover = _resolveComponent("wrap-with-popover");
  const _component_flex_row = _resolveComponent("flex-row");
  const _component_product_table_total = _resolveComponent("product-table-total");
  const _component_value_element = _resolveComponent("value-element");
  const _component_marketplace_value = _resolveComponent("marketplace-value");
  const _component_product_value = _resolveComponent("product-value");
  const _component_targeting_type_value = _resolveComponent("targeting-type-value");
  const _component_percentage_value = _resolveComponent("percentage-value");
  const _component_currency_value = _resolveComponent("currency-value");
  const _component_overlap_bar_value = _resolveComponent("overlap-bar-value");
  const _component_evolution_value = _resolveComponent("evolution-value");
  const _component_slot_with_evolution_value = _resolveComponent("slot-with-evolution-value");
  const _component_number_value = _resolveComponent("number-value");
  const _component_dot_element = _resolveComponent("dot-element");
  const _component_bar_with_value = _resolveComponent("bar-with-value");
  const _component_boxed_value = _resolveComponent("boxed-value");
  const _component_AppIcon = _resolveComponent("AppIcon");
  const _component_date_value = _resolveComponent("date-value");
  const _component_image_element = _resolveComponent("image-element");
  const _component_wrap_with_copy = _resolveComponent("wrap-with-copy");
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_variable_styled_bar = _resolveComponent("variable-styled-bar");
  const _component_layer_bars = _resolveComponent("layer-bars");
  const _component_b_table_lite = _resolveComponent("b-table-lite");
  const _component_floating_compound_table = _resolveComponent("floating-compound-table");
  return _openBlock(), _createBlock(_component_floating_compound_table, {
    ref: "performanceFloatingCompoundTable",
    datePickerDate: $options.datePickerDate,
    loading: $props.loading,
    onChangeDate: $options.handleDatePickerSubmit,
    onTableState: $options.handleTableState,
    page: $options.page,
    "onUpdate:page": _cache[0] || (_cache[0] = $event => $options.page = $event),
    totalPages: $options.totalPages,
    "onUpdate:totalPages": _cache[1] || (_cache[1] = $event => $options.totalPages = $event),
    perPage: $options.perPage,
    "onUpdate:perPage": _cache[2] || (_cache[2] = $event => $options.perPage = $event),
    style: {
      ['--compound-table-right-gap']: '16px'
    },
    fields: $options.fields,
    selectedPeriod: _ctx.period
  }, {
    header: _withCtx(() => [_createTextVNode("Breakdown by")]),
    "header-sub": _withCtx(() => [_createVNode(_component_product_table_group_by, {
      onRefresh: $options.handleGroupByRefresh,
      onClicked: $options.handleClicked,
      tabBusy: $props.loading
    }, null, 8, ["onRefresh", "onClicked", "tabBusy"])]),
    table: _withCtx(({
      fullSize,
      visible
    }) => [_createVNode(_component_b_table_lite, {
      class: _normalizeClass(['lite-table', 'search-funnel-product-table', {
        ['full-size']: fullSize
      }, {
        ['intermediate']: !fullSize && visible
      }, _ctx.groupBy]),
      style: _normalizeStyle(_ctx.cssProps),
      items: $options.filteredItems,
      fields: $options.fields,
      responsive: "",
      fixed: "",
      "sticky-header": "",
      bordered: "",
      "no-border-collapse": "",
      tbodyTrClass: item => $options.getTbodyTrClass(item),
      onHeadClicked: $options.handleHeadClick,
      onRowClicked: $options.handleRowClick,
      fieldColumnClass: field => $options.getThClass(field)
    }, _createSlots({
      "head()": _withCtx(col => [_createVNode(_component_flex_row, {
        styles: {
          justifyContent: col.field.justify,
          ...col.field.thStyle
        },
        id: `performance-product-table-${col?.column}-${_ctx.groupBy}`,
        onClick: $event => $options.handleHeadClick(col.field.key)
      }, {
        default: _withCtx(() => [_createVNode(_component_wrap_with_popover, {
          triggers: "hover",
          target: `performance-product-table-${col?.column}-${_ctx.groupBy}`,
          style: {
            width: '100%'
          }
        }, {
          title: _withCtx(() => [_createElementVNode("div", {
            innerHTML: $options.getDescriptionBasedOnKpiKey(col?.column).title
          }, null, 8, _hoisted_1)]),
          content: _withCtx(() => [_createTextVNode(_toDisplayString($options.getDescriptionBasedOnKpiKey(col?.column).detail), 1)]),
          default: _withCtx(() => [['asc', 'desc'].includes(this.sort[$data.fieldKeySwitchMap[col?.column] ?? col?.column]) ? (_openBlock(), _createBlock(_component_wrap_with_arrow, {
            key: 0,
            direction: this.sort[$data.fieldKeySwitchMap[col?.column] ?? col?.column]
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: "title",
              innerHTML: col?.label
            }, null, 8, _hoisted_2)]),
            _: 2
          }, 1032, ["direction"])) : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "title",
            innerHTML: col?.label
          }, null, 8, _hoisted_3))]),
          _: 2
        }, 1032, ["target"])]),
        _: 2
      }, 1032, ["styles", "id", "onClick"])]),
      "custom-foot": _withCtx(() => [_createElementVNode("tr", null, [_createVNode(_component_product_table_total, {
        fields: $options.fields,
        total: $options.total,
        currencyConfig: _ctx.currencyConfig,
        loading: $props.loading,
        evolutionType: _ctx.evolutionType
      }, null, 8, ["fields", "total", "currencyConfig", "loading", "evolutionType"])])]),
      "bottom-row": _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.fields, ({
        stickyColumn
      }, index) => {
        return _openBlock(), _createElementBlock("td", {
          key: index,
          class: _normalizeClass(['bottom-row', {
            'b-table-sticky-column': stickyColumn
          }])
        }, null, 2);
      }), 128))]),
      "cell(seller_name)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading,
        align: "left"
      }, {
        default: _withCtx(() => [_createVNode(_component_value_element, {
          value: $options.getSellerNameFromId(row.item?.seller_id)
        }, null, 8, ["value"])]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(sales_channel)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading,
        align: "left"
      }, {
        default: _withCtx(() => [_createVNode(_component_marketplace_value, {
          marketplace: row.item?.sales_channel,
          flag: _ctx.getCountryFlag($data.country_code_amz_sp_api_marketplace_ids_flipped[$data.amz_sp_api_marketplace_ids_country_domains_flipped[row.item?.sales_channel?.toLowerCase()]])
        }, null, 8, ["marketplace", "flag"])]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(product_name)": _withCtx(row => [_createVNode(_component_product_value, {
        value: {
          name: row.item?.standardized_product_name,
          image: row.item?.main_image_link,
          asin: row.item?.asin,
          sku: row.item?.sku,
          link: row.item?.amazon_link,
          image_channels: $options.getImageChannels(row.item?.amazon_links_by_channel)
        },
        loading: $props.loading
      }, null, 8, ["value", "loading"])]),
      "cell(search_query_type)": _withCtx(row => [_createVNode(_component_targeting_type_value, {
        value: $options.getTargetingTypeKey(row.item?.search_query_type),
        loading: $props.loading
      }, null, 8, ["value", "loading"])]),
      "cell(search_query)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading,
        align: "left",
        style: {
          "justify-content": "space-between"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_wrap_with_popover, {
          width: "fit-content",
          placement: "top"
        }, {
          title: _withCtx(() => [_createTextVNode(_toDisplayString(row.item?.search_query), 1)]),
          default: _withCtx(() => [_createElementVNode("a", {
            class: "search_query",
            href: $options.formatLink(row.item?.keyword_link),
            target: "_blank"
          }, _toDisplayString(row.item?.search_query), 9, _hoisted_4)]),
          _: 2
        }, 1024), _createVNode(_component_wrap_with_popover, {
          width: "fit-content",
          placement: "top"
        }, {
          title: _withCtx(() => [_createTextVNode(_toDisplayString($options.targetingTypeObject($options.getTargetingTypeKey(row.item?.search_query_type))?.short_name), 1)]),
          default: _withCtx(() => [_createVNode(_component_targeting_type_value, {
            value: $options.getTargetingTypeKey(row.item?.search_query_type),
            loading: $props.loading,
            useAbbreviation: true
          }, null, 8, ["value", "loading"])]),
          _: 2
        }, 1024)]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(search_revenue_share)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading,
        style: {
          "padding": "4px 8px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
          gap: 0
        }, {
          evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
            value: row.item?.[`search_revenue_share_evol${$data.evolCategory[_ctx.periodCategory]}`] * 100
          }, {
            default: _withCtx(({
              color
            }) => [_createVNode(_component_percentage_value, {
              value: row.item?.[`search_revenue_share_evol${$data.evolCategory[_ctx.periodCategory]}`],
              color: color,
              charCount: $options.minMax?.[`search_revenue_share_evol${$data.evolCategory[_ctx.periodCategory]}`]?.min <= 0.009 ? $options.maxCharCount?.percentage?.[`search_revenue_share_evol${$data.evolCategory[_ctx.periodCategory]}`] + 2 : $options.maxCharCount?.percentage?.[`search_revenue_share_evol${$data.evolCategory[_ctx.periodCategory]}`],
              precision: Math.abs(row.item?.[`search_revenue_share_evol${$data.evolCategory[_ctx.periodCategory]}`]) >= 0.001 && Math.abs(row.item?.[`search_revenue_share_evol${$data.evolCategory[_ctx.periodCategory]}`]) <= 0.009 ? 1 : 0,
              showSign: "",
              pp: "",
              tight: ""
            }, null, 8, ["value", "color", "charCount", "precision"])]),
            _: 2
          }, 1032, ["value"])]),
          default: _withCtx(() => [_createVNode(_component_overlap_bar_value, {
            value: row.item?.search_revenue_share,
            background: "",
            borderColor: "#FFE8DB",
            min: $options.minMax?.search_revenue_share?.min,
            max: $options.minMax?.search_revenue_share?.max,
            loading: $props.loading,
            align: "left",
            styles: {
              padding: 0
            },
            barStyles: {
              borderLeft: 'none',
              borderRadius: '4px',
              height: '20px',
              background: '#FFE8DB'
            }
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createVNode(_component_percentage_value, {
              value: row.item?.search_revenue_share,
              charCount: $options.maxCharCount?.percentage?.search_revenue_share + 2,
              tight: "",
              precision: 1
            }, null, 8, ["value", "charCount"]), _createVNode(_component_currency_value, {
              value: row.item?.search_revenue,
              color: "#999",
              style: {
                "font-size": "13px"
              }
            }, null, 8, ["value"])])]),
            _: 2
          }, 1032, ["value", "min", "max", "loading"])]),
          _: 2
        }, 1024)]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(seller_notoriety)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading,
        style: {
          "padding": "0px 8px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
          gap: 8
        }, {
          evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
            value: row.item?.[`seller_notoriety_evol${$data.evolCategory[_ctx.periodCategory]}`]
          }, {
            default: _withCtx(({
              color
            }) => [_createVNode(_component_percentage_value, {
              value: row.item?.[`seller_notoriety_evol${$data.evolCategory[_ctx.periodCategory]}`],
              color: color,
              charCount: $options.maxCharCount?.percentage?.[`seller_notoriety_evol${$data.evolCategory[_ctx.periodCategory]}`],
              showSign: "",
              align: "right",
              tight: ""
            }, null, 8, ["value", "color", "charCount"])]),
            _: 2
          }, 1032, ["value"])]),
          default: _withCtx(() => [_createVNode(_component_bar_with_value, {
            value: row.item?.seller_notoriety,
            min: $options.minMax?.seller_notoriety?.min,
            color: "#FFA8BD",
            max: $options.minMax?.seller_notoriety?.max,
            loading: $props.loading,
            tight: ""
          }, {
            "bar-append": _withCtx(() => [_createVNode(_component_dot_element, {
              size: 6,
              color: "#E16098",
              style: {
                "margin-left": "-3px",
                "z-index": "1",
                "align-self": "center"
              }
            })]),
            default: _withCtx(() => [_createVNode(_component_number_value, {
              value: row.item?.seller_notoriety,
              charCount: $options.maxCharCount?.number?.seller_notoriety,
              align: "right",
              tight: ""
            }, null, 8, ["value", "charCount"])]),
            _: 2
          }, 1032, ["value", "min", "max", "loading"])]),
          _: 2
        }, 1024)]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(search_query_volume)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading,
        style: {
          "padding": "0px 8px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
          gap: 8
        }, {
          evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
            value: row.item?.[`search_query_volume_evol${$data.evolCategory[_ctx.periodCategory]}`]
          }, {
            default: _withCtx(({
              color
            }) => [_createVNode(_component_percentage_value, {
              value: row.item?.[`search_query_volume_evol${$data.evolCategory[_ctx.periodCategory]}`],
              color: color,
              charCount: $options.maxCharCount?.percentage?.[`search_query_volume_evol${$data.evolCategory[_ctx.periodCategory]}`],
              showSign: "",
              align: "right",
              tight: ""
            }, null, 8, ["value", "color", "charCount"])]),
            _: 2
          }, 1032, ["value"])]),
          default: _withCtx(() => [_createVNode(_component_bar_with_value, {
            value: row.item?.search_query_volume,
            min: $options.minMax?.search_query_volume?.min,
            color: "#C1BDBD",
            max: $options.minMax?.search_query_volume?.max,
            loading: $props.loading,
            tight: ""
          }, {
            "bar-append": _withCtx(() => [_createVNode(_component_dot_element, {
              size: 6,
              color: "#9B9797",
              style: {
                "margin-left": "-3px",
                "z-index": "1",
                "align-self": "center"
              }
            })]),
            default: _withCtx(() => [_createVNode(_component_number_value, {
              value: row.item?.search_query_volume,
              charCount: $options.maxCharCount?.number?.search_query_volume,
              align: "right",
              tight: ""
            }, null, 8, ["value", "charCount"])]),
            _: 2
          }, 1032, ["value", "min", "max", "loading"])]),
          _: 2
        }, 1024)]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(impression_share)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading,
        style: {
          "padding": "0px 8px 0px 0px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
          gap: 0
        }, {
          evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
            value: row.item?.[`impression_share_evol${$data.evolCategory[_ctx.periodCategory]}`] * 100
          }, {
            default: _withCtx(({
              color
            }) => [_createVNode(_component_percentage_value, {
              value: row.item?.[`impression_share_evol${$data.evolCategory[_ctx.periodCategory]}`],
              color: color,
              charCount: $options.minMax?.[`seller_impression_share_evol${$data.evolCategory[_ctx.periodCategory]}`]?.min <= 0.009 ? $options.maxCharCount?.percentage?.[`seller_impression_share_evol${$data.evolCategory[_ctx.periodCategory]}`] + 2 : $options.maxCharCount?.percentage?.[`seller_impression_share_evol${$data.evolCategory[_ctx.periodCategory]}`],
              precision: Math.abs(row.item?.[`seller_impression_share_evol${$data.evolCategory[_ctx.periodCategory]}`]) >= 0.001 && Math.abs(row.item?.[`seller_impression_share_evol${$data.evolCategory[_ctx.periodCategory]}`]) <= 0.009 ? 1 : 0,
              showSign: "",
              pp: "",
              tight: ""
            }, null, 8, ["value", "color", "charCount", "precision"])]),
            _: 2
          }, 1032, ["value"])]),
          default: _withCtx(() => [_createVNode(_component_overlap_bar_value, {
            value: row.item?.impression_share,
            background: "",
            borderColor: "#F2F4F8",
            min: 0,
            max: Math.max($options.minMax?.click_share?.max, $options.minMax?.impression_share?.max, $options.minMax?.purchase_share?.max),
            loading: $props.loading,
            align: "left",
            styles: {
              padding: 0
            },
            barStyles: {
              borderLeft: 'none',
              borderRadius: '0px',
              height: '28px',
              background: '#F2F4F8'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_percentage_value, {
              value: row.item?.impression_share,
              charCount: $options.minMax?.impression_share?.min < 0.01 ? $options.maxCharCount?.percentage?.impression_share + 2 : $options.maxCharCount?.percentage?.impression_share + 1,
              precision: 1,
              tight: ""
            }, null, 8, ["value", "charCount"])]),
            _: 2
          }, 1032, ["value", "max", "loading"])]),
          _: 2
        }, 1024)]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(impression_count)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading,
        style: {
          "padding": "0px 8px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
          gap: 8
        }, {
          evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
            value: row.item?.[`impression_count_evol${$data.evolCategory[_ctx.periodCategory]}`]
          }, {
            default: _withCtx(({
              color
            }) => [_createVNode(_component_percentage_value, {
              value: row.item?.[`impression_count_evol${$data.evolCategory[_ctx.periodCategory]}`],
              color: color,
              charCount: $options.maxCharCount?.percentage?.[`impression_count_evol${$data.evolCategory[_ctx.periodCategory]}`],
              showSign: "",
              align: "right",
              tight: ""
            }, null, 8, ["value", "color", "charCount"])]),
            _: 2
          }, 1032, ["value"])]),
          default: _withCtx(() => [_createVNode(_component_bar_with_value, {
            value: row.item?.impression_count,
            min: $options.minMax?.impression_count?.min,
            color: "#FEC9AA",
            max: $options.minMax?.impression_count?.max,
            loading: $props.loading,
            tight: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_number_value, {
              value: row.item?.impression_count,
              charCount: $options.maxCharCount?.number?.impression_count,
              align: "right",
              tight: ""
            }, null, 8, ["value", "charCount"])]),
            _: 2
          }, 1032, ["value", "min", "max", "loading"])]),
          _: 2
        }, 1024)]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(click_share)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading,
        style: {
          "padding": "0px 8px 0px 0px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
          gap: 0
        }, {
          evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
            value: row.item?.[`click_share_evol${$data.evolCategory[_ctx.periodCategory]}`] * 100
          }, {
            default: _withCtx(({
              color
            }) => [_createVNode(_component_percentage_value, {
              value: row.item?.[`click_share_evol${$data.evolCategory[_ctx.periodCategory]}`],
              color: color,
              charCount: $options.minMax?.[`seller_click_share_evol${$data.evolCategory[_ctx.periodCategory]}`]?.min <= 0.009 ? $options.maxCharCount?.percentage?.[`seller_click_share_evol${$data.evolCategory[_ctx.periodCategory]}`] + 2 : $options.maxCharCount?.percentage?.[`seller_click_share_evol${$data.evolCategory[_ctx.periodCategory]}`],
              precision: Math.abs(row.item?.[`seller_click_share_evol${$data.evolCategory[_ctx.periodCategory]}`]) >= 0.001 && Math.abs(row.item?.[`seller_click_share_evol${$data.evolCategory[_ctx.periodCategory]}`]) <= 0.009 ? 1 : 0,
              showSign: "",
              pp: "",
              tight: ""
            }, null, 8, ["value", "color", "charCount", "precision"])]),
            _: 2
          }, 1032, ["value"])]),
          default: _withCtx(() => [_createVNode(_component_overlap_bar_value, {
            value: row.item?.click_share,
            background: "",
            borderColor: "#F2F4F8",
            min: 0,
            max: Math.max($options.minMax?.click_share?.max, $options.minMax?.impression_share?.max, $options.minMax?.purchase_share?.max),
            loading: $props.loading,
            align: "left",
            styles: {
              padding: 0
            },
            barStyles: {
              borderLeft: 'none',
              borderRadius: '0px',
              height: '28px',
              background: '#F2F4F8'
            },
            class: "click-share-bar"
          }, {
            default: _withCtx(() => [_createVNode(_component_percentage_value, {
              value: row.item?.click_share,
              charCount: $options.minMax?.click_share?.min < 0.01 ? $options.maxCharCount?.percentage?.click_share + 2 : $options.maxCharCount?.percentage?.click_share + 1,
              precision: 1,
              tight: ""
            }, null, 8, ["value", "charCount"])]),
            _: 2
          }, 1032, ["value", "max", "loading"])]),
          _: 2
        }, 1024)]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(click_count)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading,
        style: {
          "padding": "0px 8px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
          gap: 8
        }, {
          evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
            value: row.item?.[`click_count_evol${$data.evolCategory[_ctx.periodCategory]}`]
          }, {
            default: _withCtx(({
              color
            }) => [_createVNode(_component_percentage_value, {
              value: row.item?.[`click_count_evol${$data.evolCategory[_ctx.periodCategory]}`],
              color: color,
              charCount: $options.maxCharCount?.percentage?.[`click_count_evol${$data.evolCategory[_ctx.periodCategory]}`],
              showSign: "",
              align: "right",
              tight: ""
            }, null, 8, ["value", "color", "charCount"])]),
            _: 2
          }, 1032, ["value"])]),
          default: _withCtx(() => [_createVNode(_component_bar_with_value, {
            value: row.item?.click_count,
            min: $options.minMax?.click_count?.min,
            color: "#FEC9AA",
            max: $options.minMax?.click_count?.max,
            loading: $props.loading,
            tight: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_number_value, {
              value: row.item?.click_count,
              charCount: $options.maxCharCount?.number?.click_count,
              align: "right",
              tight: ""
            }, null, 8, ["value", "charCount"])]),
            _: 2
          }, 1032, ["value", "min", "max", "loading"])]),
          _: 2
        }, 1024)]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(purchase_share)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading,
        style: {
          "padding": "0px 8px 0px 0px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
          gap: 0
        }, {
          evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
            value: row.item?.[`purchase_share_evol${$data.evolCategory[_ctx.periodCategory]}`] * 100
          }, {
            default: _withCtx(({
              color
            }) => [_createVNode(_component_percentage_value, {
              value: row.item?.[`purchase_share_evol${$data.evolCategory[_ctx.periodCategory]}`],
              color: color,
              charCount: $options.minMax?.[`seller_purchase_share_evol${$data.evolCategory[_ctx.periodCategory]}`]?.min <= 0.009 ? $options.maxCharCount?.percentage?.[`seller_purchase_share_evol${$data.evolCategory[_ctx.periodCategory]}`] + 2 : $options.maxCharCount?.percentage?.[`seller_purchase_share_evol${$data.evolCategory[_ctx.periodCategory]}`],
              precision: Math.abs(row.item?.[`seller_purchase_share_evol${$data.evolCategory[_ctx.periodCategory]}`]) >= 0.001 && Math.abs(row.item?.[`seller_purchase_share_evol${$data.evolCategory[_ctx.periodCategory]}`]) <= 0.009 ? 1 : 0,
              showSign: "",
              pp: "",
              tight: ""
            }, null, 8, ["value", "color", "charCount", "precision"])]),
            _: 2
          }, 1032, ["value"])]),
          default: _withCtx(() => [_createVNode(_component_overlap_bar_value, {
            value: row.item?.purchase_share,
            background: "",
            borderColor: "#F2F4F8",
            min: 0,
            max: Math.max($options.minMax?.click_share?.max, $options.minMax?.impression_share?.max, $options.minMax?.purchase_share?.max),
            loading: $props.loading,
            align: "left",
            styles: {
              padding: 0
            },
            barStyles: {
              borderLeft: 'none',
              borderRadius: '0px',
              height: '28px',
              background: '#F2F4F8'
            },
            class: "purchase-share-bar"
          }, {
            default: _withCtx(() => [_createVNode(_component_percentage_value, {
              value: row.item?.purchase_share,
              charCount: $options.minMax?.purchase_share?.min < 0.01 ? $options.maxCharCount?.percentage?.impression_share + 2 : $options.maxCharCount?.percentage?.impression_share + 1,
              precision: 1,
              tight: ""
            }, null, 8, ["value", "charCount"])]),
            _: 2
          }, 1032, ["value", "max", "loading"])]),
          _: 2
        }, 1024)]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(purchase_count)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading,
        style: {
          "padding": "0px 8px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
          gap: 8
        }, {
          evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
            value: row.item?.[`purchase_count_evol${$data.evolCategory[_ctx.periodCategory]}`]
          }, {
            default: _withCtx(({
              color
            }) => [_createVNode(_component_percentage_value, {
              value: row.item?.[`purchase_count_evol${$data.evolCategory[_ctx.periodCategory]}`],
              color: color,
              charCount: $options.maxCharCount?.percentage?.[`purchase_count_evol${$data.evolCategory[_ctx.periodCategory]}`],
              showSign: "",
              align: "right",
              tight: ""
            }, null, 8, ["value", "color", "charCount"])]),
            _: 2
          }, 1032, ["value"])]),
          default: _withCtx(() => [_createVNode(_component_bar_with_value, {
            value: row.item?.purchase_count,
            min: $options.minMax?.purchase_count?.min,
            color: "#FEC9AA",
            max: $options.minMax?.purchase_count?.max,
            loading: $props.loading,
            tight: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_number_value, {
              value: row.item?.purchase_count,
              charCount: $options.maxCharCount?.number?.purchase_count,
              align: "right",
              tight: ""
            }, null, 8, ["value", "charCount"])]),
            _: 2
          }, 1032, ["value", "min", "max", "loading"])]),
          _: 2
        }, 1024)]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(brand_ctr)": _withCtx(row => [_createVNode(_component_boxed_value, {
        bgColor: $options.getColorsBasedOnRange(row.item?.ctr, $data.SEARCH_FUNNEL_CTR_HEATMAP_COLORS),
        loading: $props.loading
      }, {
        default: _withCtx(() => [_createVNode(_component_percentage_value, {
          value: row.item?.ctr,
          precision: 1
        }, null, 8, ["value"])]),
        _: 2
      }, 1032, ["bgColor", "loading"])]),
      "cell(conversion_rate)": _withCtx(row => [_createVNode(_component_boxed_value, {
        bgColor: $options.getColorsBasedOnRange(row.item?.conversion_rate, $data.SEARCH_FUNNEL_CVR_HEATMAP_COLORS),
        loading: $props.loading
      }, {
        default: _withCtx(() => [_createVNode(_component_percentage_value, {
          value: row.item?.conversion_rate,
          precision: 1
        }, null, 8, ["value"])]),
        _: 2
      }, 1032, ["bgColor", "loading"])]),
      "head(sf_share_of_voice)": _withCtx(col => [_createVNode(_component_flex_row, {
        styles: {
          flexDirection: 'column !important'
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          innerHTML: col?.label,
          style: {
            "padding": "4px"
          },
          class: "title"
        }, null, 8, _hoisted_6), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.getDescriptionBasedOnKpiKey(col?.column ?? '')?.sublabels, (sublabel, index) => {
          return _openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_wrap_with_popover, null, {
            title: _withCtx(() => [_createElementVNode("div", {
              innerHTML: $options.getDescriptionBasedOnKpiKey(col?.column ?? '')?.title[index]
            }, null, 8, _hoisted_9)]),
            content: _withCtx(() => [_createTextVNode(_toDisplayString($options.getDescriptionBasedOnKpiKey(col?.column ?? "")?.detail[index]), 1)]),
            default: _withCtx(() => [_createElementVNode("div", {
              innerHTML: sublabel,
              class: "title"
            }, null, 8, _hoisted_10)]),
            _: 2
          }, 1024)]);
        }), 256))])]),
        _: 2
      }, 1024)]),
      "cell(selector)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading
      }, {
        default: _withCtx(() => [_createVNode(_component_AppIcon, {
          icon: `zoom-${row.item.selected ? 'out' : 'in'}`,
          color: row.item.selected ? null : '#ADADAD',
          size: 16
        }, null, 8, ["icon", "color"])]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(period_agg)": _withCtx(row => [_createVNode(_component_date_value, {
        value: row.item?.period_agg,
        format: _ctx.getDateValueFormat,
        styles: {
          justifyContent: 'flex-start',
          ..._ctx.activateDateValueStyles(row)
        },
        loading: $props.loading
      }, null, 8, ["value", "format", "styles", "loading"])]),
      "cell(purchases_share)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading,
        style: {
          "padding": "0px 8px 0px 0px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
          gap: 0
        }, {
          evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
            value: row.item?.[`purchase_share_evol${$data.evolCategory[_ctx.periodCategory]}`] * 100
          }, {
            default: _withCtx(({
              color
            }) => [_createVNode(_component_percentage_value, {
              value: row.item?.[`purchase_share_evol${$data.evolCategory[_ctx.periodCategory]}`],
              color: color,
              charCount: $options.minMax?.[`purchase_share_evol${$data.evolCategory[_ctx.periodCategory]}`]?.min <= 0.009 ? $options.maxCharCount?.percentage?.[`purchase_share_evol${$data.evolCategory[_ctx.periodCategory]}`] + 2 : $options.maxCharCount?.percentage?.[`purchase_share_evol${$data.evolCategory[_ctx.periodCategory]}`],
              precision: Math.abs(row.item?.[`purchase_share_evol${$data.evolCategory[_ctx.periodCategory]}`]) >= 0.001 && Math.abs(row.item?.[`purchase_share_evol${$data.evolCategory[_ctx.periodCategory]}`]) <= 0.009 ? 1 : 0,
              showSign: "",
              pp: "",
              tight: ""
            }, null, 8, ["value", "color", "charCount", "precision"])]),
            _: 2
          }, 1032, ["value"])]),
          default: _withCtx(() => [_createVNode(_component_overlap_bar_value, {
            value: row.item?.purchase_share,
            background: "",
            borderColor: "#FFE5D6",
            min: $options.minMax?.purchase_share?.min,
            max: $options.minMax?.purchase_share?.max,
            loading: $props.loading,
            align: "left",
            styles: {
              padding: 0
            },
            barStyles: {
              borderLeft: 'none',
              borderRadius: '0px',
              height: '28px',
              background: '#FFE5D6'
            },
            class: "purchase-share-bar"
          }, {
            default: _withCtx(() => [_createVNode(_component_percentage_value, {
              value: row.item?.purchase_share,
              charCount: $options.minMax?.purchase_share?.min < 0.01 ? $options.maxCharCount?.percentage?.purchase_share + 2 : $options.maxCharCount?.percentage?.purchase_share + 1,
              precision: 1,
              tight: ""
            }, null, 8, ["value", "charCount"])]),
            _: 2
          }, 1032, ["value", "min", "max", "loading"])]),
          _: 2
        }, 1024)]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(top_product)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading,
        style: {
          "padding": "0px 8px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_wrap_with_popover, {
          delay: {
            show: 0,
            hide: 100
          },
          customClass: "sf-opportunities-product-popover"
        }, _createSlots({
          default: _withCtx(() => [_createVNode(_component_image_element, {
            image: row.item?.best_organic_product_image_link,
            width: 23,
            height: 23,
            borderColor: row.item?.best_organic_product_is_own_asin ? '#33B8FF' : '#E3E3E3',
            style: {
              "width": "25px",
              "height": "25px"
            }
          }, null, 8, ["image", "borderColor"])]),
          _: 2
        }, [JSON.parse(row.item?.best_organic_product) ? {
          name: "content",
          fn: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createVNode(_component_image_element, {
            image: JSON.parse(row.item?.best_organic_product)?.image,
            link: JSON.parse(row.item?.best_organic_product)?.link,
            countryCode: $data.country_code_amz_sp_api_marketplace_ids_flipped[$data.amz_sp_api_marketplace_ids_country_domains_flipped[row.item?.best_organic_own_product_sales_channel]],
            width: 38,
            height: 38,
            withFlag: "",
            withOverlay: "",
            borderColor: row.item?.best_organic_product_is_own_asin ? '#33B8FF' : '#E3E3E3',
            style: {
              "width": "40px",
              "height": "40px"
            },
            flagStyle: {
              width: '24px',
              height: '16px',
              aspectRatio: '7/5',
              bottom: '-8px',
              right: '6px'
            }
          }, null, 8, ["image", "link", "countryCode", "borderColor"]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, _toDisplayString(JSON.parse(row.item?.best_organic_product)?.title), 1), _createVNode(_component_wrap_with_copy, {
            class: "asin"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(JSON.parse(row.item?.best_organic_product)?.asin), 1)]),
            _: 2
          }, 1024)]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createVNode(_component_currency_value, {
            value: JSON.parse(row.item?.best_organic_product)?.price_value,
            currency: JSON.parse(row.item?.best_organic_product)?.price_currency
          }, null, 8, ["value", "currency"])]), _createElementVNode("div", _hoisted_17, [_createTextVNode(_toDisplayString(JSON.parse(row.item?.best_organic_product)?.rating) + " ", 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Math.round(JSON.parse(row.item?.best_organic_product)?.rating ?? 0), n => {
            return _openBlock(), _createBlock(_component_app_icon, {
              icon: "star-fill",
              color: "#F9CA51",
              size: 12,
              key: n
            });
          }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(5 - Math.round(JSON.parse(row.item?.best_organic_product)?.rating ?? 0), n => {
            return _openBlock(), _createBlock(_component_app_icon, {
              icon: "star-fill",
              color: "#E3E3E3",
              size: 12,
              key: n
            });
          }), 128)), _createTextVNode(" ("), _createVNode(_component_currency_value, {
            value: JSON.parse(row.item?.best_organic_own_product)?.reviews,
            showSymbol: false,
            allowPrecisionModification: false,
            tight: ""
          }, null, 8, ["value"]), _createTextVNode(") ")])])])])]),
          key: "0"
        } : undefined]), 1024)]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(sf_share_of_voice)": _withCtx(row => [_createVNode(_component_flex_row, null, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(['top_1_share_of_voice', 'top_3_share_of_voice', 'top_10_share_of_voice'], element => {
          return _createVNode(_component_hug_value, {
            loading: $props.loading,
            style: {
              "padding": "0px 8px"
            },
            class: "sf-share-of-voice-subelts"
          }, {
            default: _withCtx(() => [_createVNode(_component_wrap_with_popover, {
              delay: {
                show: 0,
                hide: 100
              },
              customClass: "sf-opportunities-product-popover",
              boundary: "window"
            }, _createSlots({
              default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
                gap: 0
              }, {
                evolution: _withCtx(() => [_createVNode(_component_percentage_value, {
                  value: row.item?.[element],
                  charCount: $options.maxCharCount?.percentage?.[element],
                  align: "right",
                  tight: ""
                }, null, 8, ["value", "charCount"])]),
                default: _withCtx(() => [_createVNode(_component_bar_with_value, {
                  value: row.item?.[element],
                  min: 0,
                  color: "#22863D",
                  max: 1,
                  loading: $props.loading,
                  tight: ""
                }, {
                  "bar-append": _withCtx(() => [_hoisted_25]),
                  _: 2
                }, 1032, ["value", "loading"])]),
                _: 2
              }, 1024)]),
              _: 2
            }, [row.item?.[element] && _ctx.groupBy != 'asin' ? {
              name: "content",
              fn: _withCtx(() => [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createTextVNode(_toDisplayString("ASINS Ranked Top") + " " + _toDisplayString({
                top_1_share_of_voice: 1,
                top_3_share_of_voice: 3,
                top_10_share_of_voice: 10
              }[element]) + " ", 1), _hoisted_20]), _createElementVNode("div", _hoisted_21, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(row.item?.[`asins_organic_detail_${{
                top_1_share_of_voice: 'top_1',
                top_3_share_of_voice: 'top_3',
                top_10_share_of_voice: 'top_10'
              }[element]}`]), elt => {
                return _openBlock(), _createElementBlock("div", {
                  class: "body-row",
                  key: element
                }, [_createElementVNode("div", _hoisted_22, [_createVNode(_component_image_element, {
                  image: elt?.product_image_link,
                  link: elt?.product_link,
                  withOverlay: "",
                  width: 26,
                  height: 26,
                  borderColor: elt?.is_own ? '#669EFF' : '#FF8F94',
                  style: {
                    "width": "28px",
                    "height": "28px",
                    "align-self": "flex-start"
                  }
                }, null, 8, ["image", "link", "borderColor"]), _createElementVNode("div", _hoisted_23, [_createTextVNode(_toDisplayString($options.truncateString(elt?.product_title, 60)) + " ", 1), _createElementVNode("span", _hoisted_24, _toDisplayString(elt?.asin), 1)])]), _createVNode(_component_percentage_value, {
                  value: elt?.frequency,
                  tight: "",
                  class: "attribute",
                  align: "right"
                }, null, 8, ["value"]), _createVNode(_component_number_value, {
                  value: elt?.best_organic_position,
                  tight: "",
                  prepend: "#",
                  class: "attribute",
                  align: "right"
                }, null, 8, ["value"])]);
              }), 128))])])]),
              key: "0"
            } : undefined]), 1024)]),
            _: 2
          }, 1032, ["loading"]);
        }), 64))]),
        _: 2
      }, 1024)]),
      "cell(sf_best_position)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading,
        style: {
          "padding": "0px 8px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_flex_row, {
          gap: 6,
          style: {
            "justify-content": "space-between",
            "align-items": "center",
            "width": "100%"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_number_value, {
            value: row.item?.best_organic_position,
            precision: 0,
            tight: "",
            prepend: "#"
          }, null, 8, ["value"]), _createVNode(_component_wrap_with_popover, {
            delay: {
              show: 0,
              hide: 100
            },
            customClass: "sf-opportunities-product-popover"
          }, _createSlots({
            default: _withCtx(() => [_createVNode(_component_image_element, {
              image: row.item?.best_organic_own_product_image_link,
              width: 23,
              height: 23,
              style: {
                "width": "25px",
                "height": "25px"
              }
            }, null, 8, ["image"])]),
            _: 2
          }, [_ctx.groupBy != 'asin' && JSON.parse(row.item?.best_organic_own_product) ? {
            name: "content",
            fn: _withCtx(() => [_createElementVNode("div", _hoisted_26, [_createVNode(_component_image_element, {
              image: JSON.parse(row.item?.best_organic_own_product)?.image,
              link: JSON.parse(row.item?.best_organic_own_product)?.link,
              countryCode: $data.country_code_amz_sp_api_marketplace_ids_flipped[$data.amz_sp_api_marketplace_ids_country_domains_flipped[JSON.parse(row.item?.best_organic_own_product)?.sales_channel]],
              width: 38,
              height: 38,
              withFlag: "",
              withOverlay: "",
              style: {
                "width": "40px",
                "height": "40px"
              },
              flagStyle: {
                width: '24px',
                height: '16px',
                aspectRatio: '7/5',
                bottom: '-8px',
                right: '6px'
              }
            }, null, 8, ["image", "link", "countryCode"]), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, _toDisplayString(JSON.parse(row.item?.best_organic_own_product)?.title), 1), _createVNode(_component_wrap_with_copy, {
              class: "asin"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(JSON.parse(row.item?.best_organic_own_product)?.asin), 1)]),
              _: 2
            }, 1024)]), _createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_createVNode(_component_currency_value, {
              value: JSON.parse(row.item?.best_organic_own_product)?.price_value,
              currency: JSON.parse(row.item?.best_organic_own_product)?.price_currency
            }, null, 8, ["value", "currency"])]), _createElementVNode("div", _hoisted_32, [_createTextVNode(_toDisplayString(JSON.parse(row.item?.best_organic_own_product)?.rating) + " ", 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Math.round(JSON.parse(row.item?.best_organic_own_product)?.rating ?? 0), n => {
              return _openBlock(), _createBlock(_component_app_icon, {
                icon: "star-fill",
                color: "#F9CA51",
                size: 12,
                key: n
              });
            }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(5 - Math.round(JSON.parse(row.item?.best_organic_own_product)?.rating ?? 0), n => {
              return _openBlock(), _createBlock(_component_app_icon, {
                icon: "star-fill",
                color: "#E3E3E3",
                size: 12,
                key: n
              });
            }), 128)), _createTextVNode(" ("), _createVNode(_component_currency_value, {
              value: JSON.parse(row.item?.best_organic_own_product)?.reviews,
              showSymbol: false,
              allowPrecisionModification: false,
              tight: ""
            }, null, 8, ["value"]), _createTextVNode(") ")])])])])]),
            key: "0"
          } : undefined]), 1024), _createVNode(_component_number_value, {
            value: row.item?.[`best_organic_position_evol${$data.evolCategory[_ctx.periodCategory]}`],
            color: row.item?.[`best_organic_position_evol${$data.evolCategory[_ctx.periodCategory]}`] < 0 ? '#E7747A' : '#22863D',
            charCount: $options.maxCharCount?.number?.[`best_organic_position_evol${$data.evolCategory[_ctx.periodCategory]}`],
            showSign: "",
            align: "right",
            tight: ""
          }, null, 8, ["value", "color", "charCount"])]),
          _: 2
        }, 1024)]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(sov_sponsored)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading,
        style: {
          "padding": "0px 8px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
          gap: 0
        }, {
          evolution: _withCtx(() => [_createVNode(_component_percentage_value, {
            value: row.item?.share_of_voice_sponsored,
            charCount: $options.maxCharCount?.percentage?.share_of_voice_sponsored,
            align: "right",
            tight: ""
          }, null, 8, ["value", "charCount"])]),
          default: _withCtx(() => [_createVNode(_component_bar_with_value, {
            value: row.item?.share_of_voice_sponsored,
            min: 0,
            color: "#8AB4FF",
            max: 1,
            loading: $props.loading,
            tight: ""
          }, {
            "bar-append": _withCtx(() => [_hoisted_33]),
            _: 2
          }, 1032, ["value", "loading"])]),
          _: 2
        }, 1024)]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(no_impressions_per_search)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading,
        style: {
          "padding": "0px 8px"
        },
        class: "sf-impressions-per-search"
      }, {
        default: _withCtx(() => [_createVNode(_component_wrap_with_popover, {
          delay: {
            show: 0,
            hide: 100
          },
          customClass: "sf-opportunities-product-popover"
        }, _createSlots({
          default: _withCtx(() => [_createVNode(_component_flex_row, {
            gap: 2,
            styles: {
              alignSelf: 'stretch',
              width: '100%'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_overlap_bar_value, {
              value: row.item?.sb_impressions_per_search,
              background: "",
              borderColor: "#E3D4F3",
              min: Math.min($options.minMax?.sb_impressions_per_search?.min, $options.minMax?.sp_impressions_per_search?.min),
              max: Math.max($options.minMax?.sb_impressions_per_search?.max, $options.minMax?.sp_impressions_per_search?.max),
              loading: $props.loading,
              align: "right",
              styles: {
                padding: 0,
                width: '50%'
              },
              barStyles: {
                borderLeft: 'none',
                borderRadius: '4px',
                height: '22px',
                background: '#E3D4F3'
              },
              class: "purchase-share-bar"
            }, {
              default: _withCtx(() => [_createVNode(_component_number_value, {
                value: row.item?.sb_impressions_per_search,
                precision: 1,
                tight: "",
                append: "x"
              }, null, 8, ["value"])]),
              _: 2
            }, 1032, ["value", "min", "max", "loading"]), _createVNode(_component_overlap_bar_value, {
              value: row.item?.sp_impressions_per_search,
              background: "",
              borderColor: "#EDF5FF",
              min: Math.min($options.minMax?.sp_impressions_per_search?.min, $options.minMax?.sb_impressions_per_search?.min),
              max: Math.max($options.minMax?.sp_impressions_per_search?.max, $options.minMax?.sb_impressions_per_search?.max),
              loading: $props.loading,
              align: "left",
              styles: {
                padding: 0,
                width: '50%'
              },
              barStyles: {
                borderLeft: 'none',
                borderRadius: '4px',
                height: '22px',
                background: '#EDF5FF'
              },
              class: "purchase-share-bar"
            }, {
              default: _withCtx(() => [_createVNode(_component_number_value, {
                value: row.item?.sp_impressions_per_search,
                precision: 1,
                tight: "",
                append: "x",
                color: "#2172E1"
              }, null, 8, ["value"])]),
              _: 2
            }, 1032, ["value", "min", "max", "loading"])]),
            _: 2
          }, 1024)]),
          _: 2
        }, [!_ctx.products.selectedValues?.length ? {
          name: "content",
          fn: _withCtx(() => [_createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_hoisted_36, _createVNode(_component_date_value, {
            value: row.item?.period_agg,
            format: _ctx.getDateValueFormat,
            styles: {
              justifyContent: 'flex-start',
              ..._ctx.activateDateValueStyles(row)
            },
            loading: $props.loading,
            class: "date"
          }, null, 8, ["value", "format", "styles", "loading"])]), _createElementVNode("div", _hoisted_37, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList([{
            key: 'Sponsored Brand',
            color: '#E3D4F3',
            impressions_per_search: row.item?.sb_impressions_per_search,
            impressions: row.item?.sb_impressions
          }, {
            key: 'Sponsored Product',
            color: '#8AB4FF',
            impressions_per_search: row.item?.sp_impressions_per_search,
            impressions: row.item?.sp_impressions
          }], element => {
            return _openBlock(), _createElementBlock("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_createVNode(_component_dot_element, {
              color: element.color,
              size: 10
            }, null, 8, ["color"]), _createTextVNode(" " + _toDisplayString(element.key), 1)]), _createElementVNode("div", _hoisted_40, [_createVNode(_component_number_value, {
              value: element.impressions_per_search,
              precision: 1,
              tight: "",
              append: "x",
              class: "value1",
              align: "right",
              charCount: Math.max($options.maxCharCount?.number?.sb_impressions_per_search, $options.maxCharCount?.number?.sp_impressions_per_search) + 3
            }, null, 8, ["value", "charCount"]), _createVNode(_component_currency_value, {
              value: element.impressions,
              tight: "",
              class: "value2",
              showSymbol: false,
              allowPrecisionModification: false,
              charCount: Math.max($options.maxCharCount?.currency?.sb_impressions, $options.maxCharCount?.currency?.sp_impressions)
            }, null, 8, ["value", "charCount"])])]);
          }), 256))])])]),
          key: "0"
        } : undefined]), 1024)]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(sf_click_share)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading,
        style: {
          "padding": "0px 8px"
        },
        class: "sf-click-share"
      }, {
        default: _withCtx(() => [_createVNode(_component_wrap_with_popover, {
          delay: {
            show: 0,
            hide: 100
          },
          customClass: "sf-opportunities-product-popover"
        }, _createSlots({
          default: _withCtx(() => [_createVNode(_component_flex_row, {
            styles: {
              flexDirection: 'column !important',
              position: 'relative',
              maxHeight: '32px',
              gap: '4px',
              width: '100%'
            }
          }, {
            default: _withCtx(() => [_createElementVNode("section", _hoisted_48, [_withDirectives(_createVNode(_component_percentage_value, {
              ref: "oneCurrency",
              loading: $props.loading,
              class: "little-percentage",
              value: row.item?.sp_click_ratio,
              color: "#8AB4FF",
              style: {
                "left": "0%"
              }
            }, null, 8, ["loading", "value"]), [[_vShow, parseFloat(row.item?.sp_click_ratio) > 0.13]]), _withDirectives(_createVNode(_component_percentage_value, {
              ref: "twoCurrency",
              loading: $props.loading,
              class: "little-percentage",
              value: row.item?.sb_click_ratio,
              color: "#E3D4F3",
              style: _normalizeStyle({
                left: `${parseFloat(row.item?.sp_click_ratio) * 100}%`
              })
            }, null, 8, ["loading", "value", "style"]), [[_vShow, parseFloat(row.item?.sb_click_ratio) > 0.13 && parseFloat(row.item?.sp_click_ratio) <= 0.9]]), _withDirectives(_createVNode(_component_percentage_value, {
              ref: "threeCurrency",
              loading: $props.loading,
              class: "little-percentage",
              value: row.item?.organic_click_ratio,
              color: "#22863D",
              style: _normalizeStyle({
                left: `${(parseFloat(row.item?.sb_click_ratio) + parseFloat(row.item?.sp_click_ratio)) * 100}%`
              })
            }, null, 8, ["loading", "value", "style"]), [[_vShow, parseFloat(row.item?.organic_click_ratio) > 0.13 && parseFloat(row.item?.sp_click_ratio) <= 0.9]])]), _createVNode(_component_layer_bars, null, {
              default: _withCtx(() => [_createVNode(_component_variable_styled_bar, {
                ref: "three",
                style: {
                  "--bar-radius": "0 4px 4px 0"
                },
                value: parseFloat(row.item?.organic_click_ratio) + parseFloat(row.item?.sb_click_ratio) + parseFloat(row.item?.sp_click_ratio),
                max: 1,
                min: 0,
                color: "#22863D",
                height: 6
              }, null, 8, ["value"]), _createVNode(_component_variable_styled_bar, {
                ref: "two",
                style: {
                  "--bar-radius": "0px"
                },
                value: parseFloat(row.item?.sb_click_ratio) + parseFloat(row.item?.sp_click_ratio),
                max: 1,
                min: 0,
                color: "#E3D4F3",
                height: 6
              }, null, 8, ["value"]), _createVNode(_component_variable_styled_bar, {
                ref: "one",
                style: {
                  "--bar-radius": "4px 0 0 4px"
                },
                value: parseFloat(row.item?.sp_click_ratio),
                max: 1,
                min: 0,
                color: "#8AB4FF",
                height: 6
              }, null, 8, ["value"])]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1024)]),
          _: 2
        }, [!_ctx.products.selectedValues?.length ? {
          name: "content",
          fn: _withCtx(() => [_createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_hoisted_43, _createVNode(_component_currency_value, {
            value: parseFloat(row.item?.organic_clicks) + parseFloat(row.item?.sb_clicks) + parseFloat(row.item?.sp_clicks),
            tight: "",
            class: "date",
            showSymbol: false,
            allowPrecisionModification: false
          }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_44, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList([{
            key: 'Sponsored Product',
            color: '#8AB4FF',
            ratio: row.item?.sp_click_ratio,
            clicks: row.item?.sp_clicks
          }, {
            key: 'Sponsored Brand',
            color: '#E3D4F3',
            ratio: row.item?.sb_click_ratio,
            clicks: row.item?.sb_clicks
          }, {
            key: 'Organic',
            color: '#22863D',
            ratio: row.item?.organic_click_ratio,
            clicks: row.item?.organic_clicks
          }], element => {
            return _openBlock(), _createElementBlock("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, [_createVNode(_component_dot_element, {
              color: element.color,
              size: 10
            }, null, 8, ["color"]), _createTextVNode(" " + _toDisplayString(element.key), 1)]), _createElementVNode("div", _hoisted_47, [_createVNode(_component_currency_value, {
              value: element.clicks,
              showSymbol: false,
              allowPrecisionModification: false,
              tight: "",
              class: "value1",
              align: "right",
              charCount: Math.max($options.maxCharCount?.currency?.sp_clicks, $options.maxCharCount?.currency?.sb_clicks, $options.maxCharCount?.currency?.organic_clicks)
            }, null, 8, ["value", "charCount"]), _createVNode(_component_percentage_value, {
              value: element.ratio,
              tight: "",
              class: "value2",
              charCount: Math.max($options.maxCharCount?.percentage?.sp_click_ratio, $options.maxCharCount?.percentage?.sb_click_ratio, $options.maxCharCount?.percentage?.organic_click_ratio)
            }, null, 8, ["value", "charCount"])])]);
          }), 256))])])]),
          key: "0"
        } : undefined]), 1024)]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(estimated_opportunity)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading,
        style: {
          "padding": "0px 8px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_currency_value, {
          value: row.item?.missed_opportunities,
          color: "#4D4D4D",
          style: {
            "font-size": "14px"
          },
          showSign: "",
          align: "right"
        }, null, 8, ["value"])]),
        _: 2
      }, 1032, ["loading"])]),
      _: 2
    }, [_ctx.currentTabValue === 'performance' ? {
      name: "thead-top",
      fn: _withCtx(() => [_createVNode(_component_b_tr, {
        class: "headers"
      }, {
        default: _withCtx(() => [_createVNode(_component_b_th, {
          colspan: "1",
          "sticky-column": "",
          style: {
            backgroundColor: 'inherit'
          }
        }), _createVNode(_component_b_th, {
          colspan: "1",
          "sticky-column": "",
          style: {
            backgroundColor: 'inherit'
          }
        }), _createVNode(_component_b_th, {
          colspan: "6",
          style: {
            color: '#9447FF',
            borderBottom: '1px solid #9447FF'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_hug_value, null, {
            default: _withCtx(() => [_createTextVNode("Seller performance")]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_b_th, {
          colspan: "3",
          style: {
            color: '#2172E1',
            borderBottom: '1px solid #2172E1'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_hug_value, null, {
            default: _withCtx(() => [_createTextVNode("Seller market share")]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]),
      key: "0"
    } : undefined]), 1032, ["class", "style", "items", "fields", "tbodyTrClass", "onHeadClicked", "onRowClicked", "fieldColumnClass"])]),
    _: 1
  }, 8, ["datePickerDate", "loading", "onChangeDate", "onTableState", "page", "totalPages", "perPage", "fields", "selectedPeriod"]);
}